export const modalVariants = {
  hidden: { opacity: 0, y: "100vh", x: "-50%" },
  visible: { opacity: 1, y: "-50%", x: "-50%" },
  exit: { opacity: 0, y: "100vh", x: "-50%" }
};
